module.exports = __webpack_public_path__ + "img/position-3.75385b1d.png";